<template>
  <div>
    <section class="content">
      <div class="container-fluid">
        <div class="row clearfix">
          <div class="bg-light-green" style="margin-top:-1% !important;">
            <!-- <br> -->
            <div class="row paddingku">
              <div class="col-md-4 searching">
                <span class="h_page">Laporan Pohon Kinerja</span> 
                <br />
                <br />
              </div>
              <div class="col-md-5"></div>
              <div class="col-md-3 searching">
                <div class="input-group">
                  <span class="input-group-btn">
                    <button
                      @click="Printing"
                      type="button"
                      class="btn bg-light-blue btn-sm waves-effect"
                      title="Tambah Data"
                    >
                      <i class="material-icons">print</i>
                    </button>
                  </span>
                  <input type="text" class="form-control" placeholder="Cari data" id="caridata" />
                </div>
                <br />
              </div>
            </div>
          </div>
          <div class="col-xs-12 card">
            <!-- ============================================================ MULAI ======================================================================== -->
            <br />
            <!-- <h1>ini : {{unit_kerja_full}}</h1> -->
            <div class="row">
              <div class="col-md-4">
                <span class="huruf_input">Unit Kerja</span>
                <autocomplete
                  :url="URL+ 'api/v1/simpeg_unit_kerja/autocomplete'"
                  :customHeaders="{authorization: 'kikensbatara '+token }"
                  anchor="unit_kerja"
                  :initValue="''"
                  :placeholder="unit_kerja_full"
                  :classes="{ input: 'form-control'}"
                  label="writer"
                  :onShouldRenderChild="renderChild"
                  :on-select="getAuto"
                ></autocomplete>
              </div>

              <div class="col-md-4">
                <span class="huruf_input">Tahun</span>
                <select class="form-control" v-model="form.tahun" @change="getSetupRenstra()">
                  <option value selected>-- Pilih Tahun --</option>
                  <option
                    v-for="data in list_tahun"
                    :key="data.id"
                    :value="data.tahun"
                  >{{data.tahun}}</option>
                </select>
              </div>

              <div class="col-md-4">
                <span class="huruf_input">Jenis Renja</span>
                <select class="form-control" v-model="form.renja_setup_id">
                  <option value selected>-- Pilih Tahun --</option>
                  <option
                    v-for="data in list_renja_setup"
                    :key="data.renja_setup_id"
                    :value="data.renja_setup_id"
                  >{{data.renja_jenis}}</option>
                </select>
              </div>
            </div>
            <br />

<div class="text-center">
  <b>
  <span style="font-size:120%">POHON KINERJA</span> <br>
<span style="font-size:100%">{{unit_kerja_full}}</span>
</b>

</div>
<hr>




<div class="text-center">
  <div class="tf-tree  showww">
  <ul>
    <li v-for="data in DATA" :key="data.rpjmd_misi_id">
      <span class="tf-nc rpjmd_misi_col">
        <span><b>RPJMD MISI</b></span> <br>
        <span>{{data.rpjmd_misi_no_misi}}. {{data.rpjmd_misi_uraian}}</span>
        <hr><span style="font-size:70%"><i>id : {{data.rpjmd_misi_id}}</i></span>
      </span>
      <ul>
        <li v-for="data1 in data.rpjmd_tujuan" :key="data1.rpjmd_tujuan_id">
          <span class="tf-nc rpjmd_tuj_col">
            <b><span>TUJUAN</span></b> <br>
            <span>{{data1.rpjmd_tujuan_no_tujuan}}.{{data1.rpjmd_tujuan_uraian}}</span>
            <hr><span style="font-size:70%"><i>id : {{data1.rpjmd_tujuan_id}}</i></span>
          </span>
          <ul>
            <li v-for="data2 in data1.rpjmd_sasaran" :key="data2.rpjmd_sasaran_id">
              <span class="tf-nc rpjmd_sasaran_col" data-target="misi_opd">
                  <a href="javascript:void(0);" data-target="misi_opd">
                    <b><span  data-target="misi_opd">SASARAN</span></b> <br>
                    <span data-target="misi_opd">{{data2.rpjmd_sasaran_no_sasaran}}. {{data2.rpjmd_sasaran_uraian}}</span>
                    <hr><span style="font-size:70%"><i>id : {{data2.rpjmd_sasaran_id}}</i></span>
                  </a>
              </span>
              <ul>
                <li class="misi_opd" style="display:none">
                  <span class="tf-nc indikator_col" data-target="isi_indikator_sasaran">
                      <a href="javascript:void(0);" data-target="isi_indikator_sasaran">
                        <span data-target="isi_indikator_sasaran"><b data-target="isi_indikator_sasaran">INDIKATOR SASARAN</b></span> <br>
                      </a>
                  </span>
                  <ul class="isi_indikator_sasaran"  style="display:none">
                    <li style="width: 300px !important;" v-for="data3 in data2.rpjmd_indikator_sasaran" :key="data3.rpjmd_indikator_sasaran_id">
                      <span class="tf-nc indikator_col">
                        <span><b>{{data3.rpjmd_indikator_sasaran_uraian}}</b></span> <br>
                        <span>Satuan : {{data3.rpjmd_indikator_sasaran_satuan}}</span> <hr>
                        <span>Target Tahun 1 : {{data3.rpjmd_indikator_sasaran_thn_1}}</span> <br>
                        <span>Target Tahun 2 : {{data3.rpjmd_indikator_sasaran_thn_2}}</span> <br>
                        <span>Target Tahun 3 : {{data3.rpjmd_indikator_sasaran_thn_3}}</span> <br>
                        <span>Target Tahun 4 : {{data3.rpjmd_indikator_sasaran_thn_4}}</span> <br>
                        <span>Target Tahun 5 : {{data3.rpjmd_indikator_sasaran_thn_5}}</span> <br>
                        <span>Target Tahun 6 : {{data3.rpjmd_indikator_sasaran_thn_6}}</span> <br>
                        <hr><span style="font-size:70%"><i>id : {{data3.rpjmd_indikator_sasaran_id}}</i></span>

                      </span>
                    </li>
                  </ul>
                </li>
                <li class="misi_opd" style="display:none" v-for="data33 in data2.renstra_misi" :key="data33.renstra_misi_id">
                  <span class="tf-nc rpjmd_misi_opd_col" :data-target="data33.renstra_misi_id">
                      <a href="javascript:void(0);" :data-target="data33.renstra_misi_id">
                        <b><span :data-target="data33.renstra_misi_id">MISI OPD</span></b> <hr>
                        <span :data-target="data33.renstra_misi_id">{{data33.renstra_misi_no}}. {{data33.renstra_misi_uraian}}</span>
                        <hr><span style="font-size:70%"><i>id : {{data33.renstra_misi_id}}</i></span>
                      </a>
                  </span>
                  <ul :class="data33.renstra_misi_id+''" style="display:none">
                    <li v-for="data4 in data33.renstra_sasaran" :key="data4.renstra_sasaran_id">
                      <span class="tf-nc rpjmd_sasaran_col" :data-target="data4.renstra_sasaran_id">
                          <a  href="javascript:void(0);" :data-target="data4.renstra_sasaran_id">
                            <b><span :data-target="data4.renstra_sasaran_id">SASARAN OPD</span> <hr></b>
                            <span :data-target="data4.renstra_sasaran_id">{{data4.renstra_sasaran_no}}. {{data4.renstra_sasaran_uraian}}</span>
                          </a>
                          <hr><span style="font-size:70%"><i>id : {{data4.renstra_sasaran_id}}</i></span>
                      </span>
                      <ul>
                        <li :class="data4.renstra_sasaran_id+''" style="display:none">
                          <span class="tf-nc indikator_col" :data-target="data4.renstra_sasaran_id+'xx'" >
                              <a href="javascript:void(0);" :data-target="data4.renstra_sasaran_id+'xx'">
                                <b><span :data-target="data4.renstra_sasaran_id+'xx'">INDIKATOR SASARAN STRATEGIS</span></b> <br>
                              </a>
                          </span>
                          <ul  :class="data4.renstra_sasaran_id+'xx'+''" style="display:none">
                            <li style="width: 300px !important;" v-for="data55 in data4.renstra_indikator_sasaran" :key="data55.renstra_indikator_sasaran_id">
                              <span class="tf-nc indikator_col">
                                  <span><b>{{data55.renstra_indikator_sasaran_no_indikator}}. {{data55.renstra_indikator_sasaran_uraian}}</b></span> <br>
                                  <span>Satuan : {{data55.renstra_indikator_sasaran_satuan}}</span> <hr>
                                  <span>Target Tahun 1 : {{data55.renstra_indikator_sasaran_thn_1}}</span> <br>
                                  <span>Target Tahun 2 : {{data55.renstra_indikator_sasaran_thn_2}}</span> <br>
                                  <span>Target Tahun 3 : {{data55.renstra_indikator_sasaran_thn_3}}</span> <br>
                                  <span>Target Tahun 4 : {{data55.renstra_indikator_sasaran_thn_4}}</span> <br>
                                  <span>Target Tahun 5 : {{data55.renstra_indikator_sasaran_thn_5}}</span> <br>
                                  <span>Target Tahun 6 : {{data55.renstra_indikator_sasaran_thn_6}}</span> <br>

                              </span>
                            </li>
                          </ul>
                        </li>

                        <li :class="data4.renstra_sasaran_id+' '" style="display:none">
                          <span class="tf-nc program_col" :data-target="data4.renstra_sasaran_id+'xyz'">
                              <a  href="javascript:void(0);" :data-target="data4.renstra_sasaran_id+'xyz'">
                                <b> <span  :data-target="data4.renstra_sasaran_id+'xyz'" >PROGRAM</span></b>
                              </a>
                          </span>
                          <ul :class="data4.renstra_sasaran_id+'xyz'" style="display:none">
                            <li v-for="data5 in data4.renja_program" :key="data5.renja_program_renja_program_id">
                              <span class="tf-nc isi_program_col" :data-target="data5.renja_program_renja_program_id">
                                  <a  href="javascript:void(0);" :data-target="data5.renja_program_renja_program_id">
                                      <span :data-target="data5.renja_program_renja_program_id">
                                       <b> <i :data-target="data5.renja_program_renja_program_id">{{data5.renja_program_kode}}. {{data5.renja_program_nama}}</i></b>
                                      </span>
                                      <hr><span style="font-size:70%"><i>id : {{data5.renja_program_renja_program_id}}</i></span>
                                  </a>
                              </span>
                              <ul :class="data5.renja_program_renja_program_id" style="display:none">
                                <li >
                                  <span class="tf-nc indikator_col" :data-target="data5.renja_program_renja_program_id+'keg'">
                                    <a  href="javascript:void(0);" :data-target="data5.renja_program_renja_program_id+'keg'">
                                        <b><span :data-target="data5.renja_program_renja_program_id+'keg'">KEGIATAN</span></b>
                                    </a>
                                  </span>
                                  <ul :class="data5.renja_program_renja_program_id+'keg'" style="display:none">
                                    <li v-for="data6 in data5.renja_kegiatan" :key="data6.renja_kegiatan_id">
                                      <span class="tf-nc indikator_col" :data-target="data6.renja_kegiatan_id">
                                          <a  href="javascript:void(0);" :data-target="data6.renja_kegiatan_id">
                                              <i><b><span :data-target="data6.renja_kegiatan_id">{{data6.renja_kegiatan_kode}}. {{data6.renja_kegiatan_nama}}</span></b></i>
                                          </a>
                                      </span>
                                      <ul :class="data6.renja_kegiatan_id" style="display:none">
                                        <li>
                                          <span class="tf-nc indikator_col" :data-target="data6.renja_kegiatan_id+'ind'">
                                              <a  href="javascript:void(0);" :data-target="data6.renja_kegiatan_id+'ind'">
                                                  <b><span :data-target="data6.renja_kegiatan_id+'ind'">INDIKATOR KEGIATAN</span></b>
                                              </a>
                                          </span>
                                          <ul :class="data6.renja_kegiatan_id+'ind'" style="display:none">
                                            <li style="width: 300px !important;" v-for="data77 in data6.renja_kegiatan_indikator" :key="data77.renja_kegiatan_indikator_id">
                                              <span class="tf-nc indikator_col">
                                                  <span><b>{{data77.renja_kegiatan_indikator_no_indikator}}. {{data77.renja_kegiatan_indikator_uraian}}</b></span> <hr>
                                                  <span>Satuan : {{data77.renja_kegiatan_indikator_satuan}}</span> <br>
                                                  <span>Realisasi Thn Lalu : {{data77.renja_kegiatan_indikator_realisasi_thn_lalu}}</span> <br>
                                                  <span>Realisasi Thn Ini : {{data77.renja_kegiatan_indikator_target_thn_ini}}</span> <br>
                                              </span>
                                            </li>
                                          </ul>
                                        </li>
                                        <li>
                                          <span class="tf-nc indikator_col" :data-target="data6.renja_kegiatan_id+'ssr'">
                                              <a  href="javascript:void(0);" :data-target="data6.renja_kegiatan_id+'ssr'">
                                                  <b><span :data-target="data6.renja_kegiatan_id+'ssr'">SASARAN KEGIATAN</span></b>
                                              </a>
                                          </span>
                                          <ul :class="data6.renja_kegiatan_id+'ssr'" style="display:none">
                                            <li v-for="data7 in data6.renja_kegiatan_sasaran" :key="data7.renja_kegiatan_sasaran_id">
                                              <span class="tf-nc indikator_col">
                                                  <b><span>{{data7.renja_kegiatan_sasaran_no}}. {{data7.renja_kegiatan_sasaran_uraian}}</span></b>
                                              </span>
                                            </li>
                                          </ul>
                                        </li>
                                      </ul>
                                    </li>
                                  </ul>
                                </li>
                                <li>
                                  <span class="tf-nc indikator_col" :data-target="data5.renja_program_renja_program_id+'ind'">
                                      <a  href="javascript:void(0);" :data-target="data5.renja_program_renja_program_id+'ind'" >
                                          <b><span :data-target="data5.renja_program_renja_program_id+'ind'">INDIKATOR PROGRAM</span></b>
                                      </a>
                                  </span>
                                  <ul :class="data5.renja_program_renja_program_id+'ind'" style="display:none"  v-for="data66 in data5.renja_program_indikator" :key="data66.renja_program_indikator_id">
                                    <li style="width: 300px !important;">
                                      <span class="tf-nc indikator_col">
                                          <span><b>{{data66.renja_program_indikator_no_indikator}}. {{data66.renja_program_indikator_uraian}}</b></span> <hr>
                                          <span>Satuan : {{data66.renja_program_indikator_satuan}}</span> <br>
                                          <span>Rumus Satuan : {{data66.renja_program_indikator_rumus_satuan}}</span> <br>
                                          <span>Target : {{data66.renja_program_indikator_target}}</span> <br>
                                      </span>
                                    </li>
                                  </ul>
                                </li>
                                <li>
                                  <span class="tf-nc indikator_col" :data-target="data5.renja_program_renja_program_id+'ssr'">
                                      <a  href="javascript:void(0);" :data-target="data5.renja_program_renja_program_id+'ssr'">
                                          <b><span :data-target="data5.renja_program_renja_program_id+'ssr'">SASARAN PROGRAM</span></b>
                                      </a>
                                  </span>
                                  <ul :class="data5.renja_program_renja_program_id+'ssr'"  v-for="data666 in data5.renja_program_sasaran" :key="data666.renja_program_sasaran_id" style="display:none">
                                    <li>
                                      <span class="tf-nc indikator_col">
                                          <b><span>{{data666.renja_program_sasaran_no}}. {{data666.renja_program_sasaran_uraian}}</span></b>
                                      </span>
                                    </li>
                                  </ul>
                                </li>
                            </ul>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>

          </ul>
        </li>
      </ul>
    </li>
  </ul>
</div>

</div>











            <hr/>

            <div id="printMe">

















            </div>
            <br />
            <hr />
            <!-- ============================================================ MODAL ======================================================================== -->

            <!-- ============================================================ MODAL ======================================================================== -->
            <!-- ============================================================ MULAI ======================================================================== -->
          </div>
        </div>
      </div>
    </section>
  </div>
</template>



<script>
const ADD_URL = URL_APP + "api/v1/sakip_lap_pohon_kinerja/";
const ADD_URL_TAHUN = URL_APP + "api/v1/planning_tahun/";



const URL_SERVER = URL_APP;
import Autocomplete from "vue2-autocomplete-js";




export default {
  name: "",
  components: { Autocomplete },
  data() {
    return {
      form: {
        jabatan_id: "",
        target: 0,
        keterangan: "",

        renja_kegiatan_id: "",

        renja_setup_id: "",
        tahun: "",
        instansi_id: "",
        unit_kerja: ""
      },

      nested : true,

      unit_kerja: "",
      unit_kerja_full: "",
      instansi_id: "",
      DATA : [],

      list_renja_setup: [],

      list_data: [],

      list_tahun: [],

      token: localStorage.token,
      URL: URL_SERVER,
      
    };
  },

  mounted() {
    $(".hilang").hide();
    var get_profile = JSON.parse(localStorage.profile);
    this.unit_kerja_full = get_profile.profile.unit_kerja_nama;
    this.unit_kerja = get_profile.profile.unit_kerja;
    this.form.unit_kerja = get_profile.profile.unit_kerja;

    this.form.instansi_id = get_profile.profile.instansi_id;
    this.instansi_id = get_profile.profile.instansi_id;

    localStorage.sidemenu = "sakip";

    this.getData();


    $(".showww").click(function(ev) {
        var t = ev.srcElement || ev.target;
        var classHide = $(t).attr('data-target');
        console.log(t)
        $('.'+classHide+'').fadeToggle();
    });

  },

  // =============================================================== METHODS =========================================================================
  methods: {
    emptyData: function() {},
    getData : function(){
      fetch(ADD_URL +'level_III', {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization: "kikensbatara " + localStorage.token
        },
        body : JSON.stringify({
          unit_kerja : this.form.unit_kerja
        })
      }).then(res => res.json()).then((res_data)=>{
          console.log(res_data);
          this.DATA = res_data;
          $(".hilang").hide();
      })
    },

    // ================== AUTOCOMPLETE ====================
    renderChild(data) {
      return `
                <span><b>${data.unit_kerja}</b></span>
                <span style='font-size:80%'>${data.ref_instansi}</span>
                `;
    },
    getAuto: function(obj) {
      this.list_data = [];
      this.unit_kerja = obj.id;
      this.unit_kerja_full = obj.unit_kerja;
      this.form.unit_kerja = obj.id;

      this.form.instansi_id = obj.instansi_id;
      this.instansi_id = obj.instansi_id;
      console.log(obj);
      this.getData()
    },
    Printing: function() {
      // printMe
      var elem = document.getElementById("printMe");
      var domClone = elem.cloneNode(true);

      var $printSection = document.getElementById("printSection");

      if (!$printSection) {
        var $printSection = document.createElement("div");
        $printSection.id = "printSection";
        document.body.appendChild($printSection);
      }

      $printSection.innerHTML = "";
      $printSection.appendChild(domClone);
      window.print();
    },
    // ================== AUTOCOMPLETE ====================
  }
  // =============================================================== METHODS =========================================================================
};
</script>

<style>
    a {
        text-decoration: none !important;
        color: #505050;
    }
</style>

